<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'SHARED.TOOLBAR_UNPAID_LABEL' | translate }}</h3>
    </div>
    <div class="sp-row__align">
      <div
        class="sp-order__status-radius sp-row__center sp-padding__left sp-padding__right sp-background__primary-contrast">
        <span class="sp-text__ellipsized sp-text__center">{{ unpaids?.length || 0 }}</span>
      </div>
    </div>
  </div>
  <div *ngFor="let unpaid of getSortedUnpaid()">
    <div
      *ngIf="unpaids?.length"
      class="sp-background__primary-contrast sp-margin sp-margin__top-x2 sp-border-radius sp-padding__x2">
      <div class="sp-margin__left">
        <div class="sp-row__align">
          <span class="sp-color__accent">{{ 'STEPS.STEP_LABEL' | translate }} {{ (unpaid?.step_index ?? 0) + 1 }}</span>
          <span class="sp-color__accent sp-margin__left sp-margin__right"> - </span>
          <app-shared-id
            [content]="unpaid?.step_id || '-'"
            [content_class]="'sp-color__accent'"
            [is_shrinked_id]="true"></app-shared-id>
        </div>
        <div class="sp-row__space">
          <div class="sp-row__align">
            <span
              >{{ (unpaid.amount || 0) / 100 | number : '0.2-2' }}{{ getCurrencyLabel(unpaid) }} -
              {{ unpaid.due_date | date : 'dd/MM/yyyy' }}</span
            >
          </div>
          <div class="sp-row__align">
            <div
              [ngClass]="getStepStatusClass(unpaid.status)"
              class="sp-order__status-radius sp-row__center sp-padding__horiz sp-width__fit-content">
              <span class="sp-text__ellipsized sp-text__center">{{
                getStepStatusLabel(unpaid.status) | translate | lowercase
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
